import { render, staticRenderFns } from "./igt-boolean-setting.vue?vue&type=template&id=7093dd88&scoped=true&"
import script from "./igt-boolean-setting.vue?vue&type=script&lang=js&"
export * from "./igt-boolean-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7093dd88",
  null
  
)

export default component.exports